import axios from "axios";
import * as Config from "../../Utils/Config";



export async function get_DashboardData(data) {
    try {
        const res = await axios.post(`${Config.base_url}getdashboard`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}















